// Polyfills
import "es6-promise/auto";
import "babel-polyfill";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import { ColorThemePlugin } from "vuestic-ui/src/services/ColorThemePlugin";
import store from "../store/index";
import router from "../router/index";
import VuesticPlugin from "vuestic-ui/src/components/vuestic-plugin";
import "../i18n/index";
import YmapPlugin from "vue-yandex-maps";
import VueClipboard from "vue-clipboard2";
import VeeValidate from "vee-validate";
import VTooltip from "v-tooltip";

// workaround for custom vuetable import detailed row as component
import DetailRow from "../components/journal/DetailRow.vue";
import DetailRowPartenaires from "../components/journal/DetailRowPartenaires.vue";
import DetailRowRetours from "../components/retours/DetailRowRetours.vue";

import axios from "axios";

// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, { fieldsBagName: "formFields" });
Vue.use(VuesticPlugin);
Vue.use(YmapPlugin);
Vue.use(VueClipboard);
Vue.use(VTooltip);

Vue.component("DetailRow", DetailRow);
Vue.component("DetailRowPartenaires", DetailRowPartenaires);
Vue.component("DetailRowRetours", DetailRowRetours);

Vue.use(ColorThemePlugin, {
  // Add or change theme colors here
  themes: {
    // primary: '#f06595',
    // blurple: '#7289DA',
  }
});

axios.defaults.withCredentials = true;
Vue.prototype.$http = axios;

// set loading status
router.beforeEach((to, from, next) => {
  store.commit("setLoading", true);
  store.dispatch("udateStats");
  store.dispatch("loadListeCCN");

  const ensureRouteAccess = () => {
    if (
      to.matched.some(record => record.meta.requiresAdmin) &&
      (!store.getters.user ||
        !store.getters.user.droits ||
        store.getters.user.droits !== "ADMIN")
    ) {
      next("/");
      return;
    }

    next();
  };

  if (to.matched.some(record => record.meta.requiresAuth)) {
    //todo should check directly with axios or cookie
    if (store.getters.isLoggedIn) {
      ensureRouteAccess();
    } else {
      axios
        .get("/api/user")
        .then(res => {
          if (res.data.isauthenticated) {
            store
              .dispatch("refresh_user", res.data.user)
              .then(() => {
                ensureRouteAccess();
              })
              .catch(err => console.log(err));
          } else {
            next("/auth/login");
          }
        })
        .catch(err => {
          console.log(err);
          next("/auth/login");
        });
    }
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  store.commit("setLoading", false);
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});
